webpackJsonp([345],{

/***/ 1193:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PlatformUserAllotManyForm_vue__ = __webpack_require__(2905);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1d6a6842_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PlatformUserAllotManyForm_vue__ = __webpack_require__(5172);
function injectStyle (ssrContext) {
  __webpack_require__(5170)
}
var normalizeComponent = __webpack_require__(11)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-1d6a6842"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PlatformUserAllotManyForm_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1d6a6842_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PlatformUserAllotManyForm_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 2905:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      inputWith: 12,
      findBy: 'department',
      formRules: {
        customerid: [{ type: 'array', required: true, message: '客户不能为空', trigger: 'blur' }],
        adminuser: [{ type: 'array', required: true, message: '管理员不能为空', trigger: 'blur' }]
      },

      dataModel: {
        customerid: [],
        adminuser: []
      },
      selectedDepartmentUsers: [],

      optionModel: {
        customers: [],
        adminusers: []
      },

      inLoading: {
        customerid: false,
        adminuser: false
      },
      departments: []
    };
  },
  created: function created() {
    var _this = this;

    request.common('getDepartmentsIndex', { current_page: 1, per_page: 500 }).then(function (_ref) {
      var data = _ref.data;

      _this.departments = data.data.map(function (it) {
        return {
          label: it.name,
          value: it.id
        };
      });
    });
  },

  methods: {
    onSearchCustomers: function onSearchCustomers() {
      var _this2 = this;

      var val = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

      if (val) {
        this.inLoading.customerid = true;

        request.alert('getCustomerTable', {
          keyword: val,
          type: [10, 70] // 仅支持搜索大客户、爱绩效客户
        }).then(function (_ref2) {
          var data = _ref2.data;

          _this2.inLoading.customerid = false;
          _this2.optionModel.customers = data.data;
        }).catch(function () {
          _this2.inLoading.customerid = false;
        });
      } else {
        this.optionModel.customers = [];
      }
    },
    onSearchAdminusers: function onSearchAdminusers() {
      var _this3 = this;

      var val = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

      if (val) {
        this.inLoading.adminuser = true;

        request.alert('getBasicPlatformUsersIndex', {
          name: val,
          status: [1, 2]
        }).then(function (_ref3) {
          var data = _ref3.data;

          _this3.inLoading.adminuser = false;
          _this3.optionModel.adminusers = data.data;
        }).catch(function () {
          _this3.inLoading.adminuser = false;
        });
      } else {
        this.optionModel.adminusers = [];
      }
    },
    onChangeCustomerId: function onChangeCustomerId() {
      this.optionModel.customers = [];
    },
    onChangeAdminuser: function onChangeAdminuser() {
      this.optionModel.adminusers = [];
    },
    onChangeCustomerVisible: function onChangeCustomerVisible(isShow) {
      if (isShow) return;
      this.optionModel.customers = [];
    },
    onChangeAdminuserVisible: function onChangeAdminuserVisible(isShow) {
      if (isShow) return;
      this.optionModel.adminusers = [];
    },
    getForm: function getForm() {
      var result = filter.copyJson(this.dataModel);
      result.adminuser = this.getSelectedAdminuserIds();

      return result;
    },
    getSelectedAdminuserIds: function getSelectedAdminuserIds() {
      if (this.findBy === 'search') {
        return this.dataModel.adminuser;
      }
      return this.selectedDepartmentUsers.map(function (it) {
        return it[1];
      }).filter(function (it) {
        return !!it;
      });
    },
    onSubmit: function onSubmit() {
      var _this4 = this;

      var validator = this.findBy === 'department' ? function (func) {
        return func(true);
      } : this.$refs.form.validate;
      validator(function (valid) {
        if (!valid) {
          _this4.$message.error('提交内容填写不正确！');
          return;
        }
        var form = _this4.getForm();
        if (form.adminuser.length <= 0) {
          _this4.$message.error('请选择管理员！');
          return;
        }
        if (form.customerid.length <= 0) {
          _this4.$message.error('请选择客户！');
          return;
        }

        request.common('AllotPlatformUserMany', _this4.getForm()).then(function () {
          _this4.$message.success('分配成功');
          _this4.$router.replace({ name: '后台用户管理' });
        });
      });
    },
    lazyLoadAdminUsers: function lazyLoadAdminUsers(node, resolve) {
      if (node.root || node.data.leaf) {
        resolve([]);
        return;
      }
      request.common('getBasicPlatformUsersIndex', {
        current_page: 1,
        per_page: 1000,
        usertype: [2, 3],
        status: [1, 2],
        department_id: node.data.value
      }).then(function (_ref4) {
        var data = _ref4.data;

        resolve(data.data.map(function (it) {
          return {
            label: it.name,
            value: it.id,
            leaf: true
          };
        }));
      });
    }
  }
});

/***/ }),

/***/ 5170:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(5171);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(991)("1ed4aa33", content, true, {});

/***/ }),

/***/ 5171:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(990)(true);
// imports


// module
exports.push([module.i, ".custom-form .re-el-form__flex[data-v-1d6a6842]{margin:0}.custom-form .el-select[data-v-1d6a6842]{width:100%}.custom-form .form-panel[data-v-1d6a6842]{width:100%;margin:15px 0 0}.custom-form .form-slider[data-v-1d6a6842]{padding:0 0 0 10px}.popover-table[data-v-1d6a6842]{position:fixed;top:0;bottom:0;left:0;right:0;margin:0;background-color:rgba(0,0,0,.5);z-index:999}.popover-table .popover-table-body[data-v-1d6a6842]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-flow:column nowrap;flex-flow:column nowrap;-webkit-box-pack:start;-ms-flex-pack:start;justify-content:flex-start;max-height:80%;min-height:200px;max-width:80%;margin:auto;background-color:#fff;border-radius:5px;overflow:hidden}.popover-table .popover-table-body>div[data-v-1d6a6842]{width:100%;-webkit-box-sizing:border-box;box-sizing:border-box;padding:15px}.popover-table .popover-table-body .popover-table-header[data-v-1d6a6842]{-webkit-box-flex:0;-ms-flex-positive:0;flex-grow:0;-ms-flex-negative:0;flex-shrink:0;font-size:16px;font-weight:900;color:#666;border-bottom:1px dashed #aaa}.popover-table .popover-table-body .popover-table-content[data-v-1d6a6842]{-webkit-box-flex:1;-ms-flex-positive:1;flex-grow:1;-ms-flex-negative:1;flex-shrink:1;overflow:auto}", "", {"version":3,"sources":["/workspace/src/views/platform-user/style/PlatformUser.scss"],"names":[],"mappings":"AACA,gDAAgD,QAAQ,CACvD,AACD,yCAAyC,UAAU,CAClD,AACD,0CAA0C,WAAW,eAAe,CACnE,AACD,2CAA2C,kBAAkB,CAC5D,AACD,gCAAgC,eAAe,MAAM,SAAS,OAAO,QAAQ,SAAS,gCAAiC,WAAW,CACjI,AACD,oDAAoD,oBAAoB,oBAAoB,aAAa,4BAA4B,6BAA6B,4BAA4B,wBAAwB,uBAAuB,oBAAoB,2BAA2B,eAAe,iBAAiB,cAAc,YAAY,sBAAsB,kBAAkB,eAAe,CAC5Y,AACD,wDAAwD,WAAW,8BAA8B,sBAAsB,YAAY,CAClI,AACD,0EAA0E,mBAAmB,oBAAoB,YAAY,oBAAoB,cAAc,eAAe,gBAAgB,WAAW,6BAA6B,CACrO,AACD,2EAA2E,mBAAmB,oBAAoB,YAAY,oBAAoB,cAAc,aAAa,CAC5K","file":"PlatformUser.scss","sourcesContent":["\n.custom-form .re-el-form__flex[data-v-1d6a6842]{margin:0\n}\n.custom-form .el-select[data-v-1d6a6842]{width:100%\n}\n.custom-form .form-panel[data-v-1d6a6842]{width:100%;margin:15px 0 0\n}\n.custom-form .form-slider[data-v-1d6a6842]{padding:0 0 0 10px\n}\n.popover-table[data-v-1d6a6842]{position:fixed;top:0;bottom:0;left:0;right:0;margin:0;background-color:rgba(0,0,0,0.5);z-index:999\n}\n.popover-table .popover-table-body[data-v-1d6a6842]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-flow:column nowrap;flex-flow:column nowrap;-webkit-box-pack:start;-ms-flex-pack:start;justify-content:flex-start;max-height:80%;min-height:200px;max-width:80%;margin:auto;background-color:#FFF;border-radius:5px;overflow:hidden\n}\n.popover-table .popover-table-body>div[data-v-1d6a6842]{width:100%;-webkit-box-sizing:border-box;box-sizing:border-box;padding:15px\n}\n.popover-table .popover-table-body .popover-table-header[data-v-1d6a6842]{-webkit-box-flex:0;-ms-flex-positive:0;flex-grow:0;-ms-flex-negative:0;flex-shrink:0;font-size:16px;font-weight:900;color:#666;border-bottom:1px dashed #AAA\n}\n.popover-table .popover-table-body .popover-table-content[data-v-1d6a6842]{-webkit-box-flex:1;-ms-flex-positive:1;flex-grow:1;-ms-flex-negative:1;flex-shrink:1;overflow:auto\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 5172:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"title",rawName:"v-title",value:(_vm.$route.meta.title),expression:"$route.meta.title"}]},[_c('div',{staticClass:"page-heading"},[_c('h3',[_vm._v(_vm._s(_vm.$route.meta.title))]),_vm._v(" "),_c('el-breadcrumb',{attrs:{"separator-class":"el-icon-arrow-right"}},[_c('el-breadcrumb-item',{attrs:{"to":{ path: '/' }}},[_vm._v("首页")]),_vm._v(" "),_c('el-breadcrumb-item',{attrs:{"to":{ name: '后台用户管理' }}},[_vm._v("后台用户管理")]),_vm._v(" "),_c('el-breadcrumb-item',[_vm._v(_vm._s(_vm.$route.meta.title))])],1)],1),_vm._v(" "),_c('layout-panel',{scopedSlots:_vm._u([{key:"header",fn:function(){return [_vm._v("表单")]},proxy:true}])},[_vm._v(" "),_c('el-form',{ref:"form",attrs:{"model":_vm.dataModel,"rules":_vm.formRules,"label-width":"160px"},nativeOn:{"submit":function($event){$event.preventDefault();return _vm.onSubmit()}}},[_c('div',{staticClass:"re-el-form__flex"},[_c('div',{staticClass:"medium"},[_c('el-form-item',{attrs:{"prop":"customerid","label":"客户:"}},[_c('el-select',{staticClass:"width-max",attrs:{"remote-method":_vm.onSearchCustomers,"loading":_vm.inLoading.customerid,"size":"small","multiple":"","filterable":"","remote":"","clearable":""},on:{"visible-change":_vm.onChangeCustomerVisible,"change":_vm.onChangeCustomerId},model:{value:(_vm.dataModel.customerid),callback:function ($$v) {_vm.$set(_vm.dataModel, "customerid", $$v)},expression:"dataModel.customerid"}},_vm._l((_vm.optionModel.customers),function(item){return _c('el-option',{key:item.id,attrs:{"label":item.name,"value":item.id}})}),1)],1),_vm._v(" "),_c('el-form-item',{attrs:{"prop":"adminuser","label":"管理员:"}},[_c('el-radio',{attrs:{"label":"department"},model:{value:(_vm.findBy),callback:function ($$v) {_vm.findBy=$$v},expression:"findBy"}},[_vm._v("按部门选择")]),_vm._v(" "),_c('el-radio',{attrs:{"label":"search"},model:{value:(_vm.findBy),callback:function ($$v) {_vm.findBy=$$v},expression:"findBy"}},[_vm._v("按搜索选择")]),_vm._v(" "),_c('div',{staticStyle:{"padding-bottom":"100px"}},[_c('el-cascader',{directives:[{name:"show",rawName:"v-show",value:(_vm.findBy === 'department'),expression:"findBy === 'department'"}],staticClass:"width-max",attrs:{"options":_vm.departments,"size":"small","props":{multiple: true, lazy: true, lazyLoad: _vm.lazyLoadAdminUsers}},model:{value:(_vm.selectedDepartmentUsers),callback:function ($$v) {_vm.selectedDepartmentUsers=$$v},expression:"selectedDepartmentUsers"}}),_vm._v(" "),_c('el-select',{directives:[{name:"show",rawName:"v-show",value:(_vm.findBy === 'search'),expression:"findBy === 'search'"}],staticClass:"width-max",attrs:{"remote-method":_vm.onSearchAdminusers,"placeholder":"请输入关键词进行搜索","loading":_vm.inLoading.adminuser,"size":"small","multiple":"","filterable":"","remote":""},on:{"visible-change":_vm.onChangeAdminuserVisible,"change":_vm.onChangeAdminuser},model:{value:(_vm.dataModel.adminuser),callback:function ($$v) {_vm.$set(_vm.dataModel, "adminuser", $$v)},expression:"dataModel.adminuser"}},_vm._l((_vm.optionModel.adminusers),function(item){return _c('el-option',{key:item.id,attrs:{"label":item.name,"value":item.id}})}),1)],1)],1),_vm._v(" "),_c('el-form-item',[_c('el-button',{attrs:{"type":"primary","native-type":"submit"}},[_vm._v("保存\n            ")]),_vm._v(" "),_c('el-button',{on:{"click":function($event){return _vm.$router.push({name: '后台用户管理'})}}},[_vm._v("取消\n            ")])],1)],1)])])],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ })

});


// WEBPACK FOOTER //
// static/js/PlatformUserAllotManyForm.324c895c9044941300e5.js